// storage keys
export const ACCESS_TOKEN_KEY = 'DV_ACCESS_TOKEN'
export const REFRESH_TOKEN_KEY = 'DV_REFRESH_TOKEN'
